<template>
  <div id="app">
    <SiteNav v-if="!$route.path.startsWith('/sell/')" />
    <router-view />
    <SiteFooter v-if="!$route.path.startsWith('/sell/')" />
  </div>
</template>

<script>
import SiteNav from '@/components/SiteNav.vue';
import SiteFooter from '@/components/SiteFooter.vue';

export default {
  components: {
    SiteNav,
    SiteFooter,
  },
};
</script>
